/*
This functions purpose is to format the book customisation characters into a formatted string
ex: John & Mary; Joe, Bob, Dan & 3 others
*/

export const formatGifteeNameList = (
  characters: string | string[],
  label: string
) => {
  if (typeof characters === "string") {
    return characters;
  }
  if (characters?.length === 1) {
    return characters[0];
  }

  if (characters?.length > 1 && characters?.length < 4) {
    return `${characters?.slice(0, -1).join(", ")} & ${characters?.at(-1)}`;
  }

  if (characters?.length > 3) {
    const firstThreeCharacters = characters?.slice(0, 3);
    const remainingCharacters =
      characters?.length - firstThreeCharacters.length;
    return `${firstThreeCharacters.join(
      ", "
    )} & ${remainingCharacters} ${label}`;
  }
};
